import React, { useContext, useState } from 'react'
import { ContextGloball } from '../Context/ContextGlobal';
import ReporteReuqerimiento from './ReporteReuqerimiento';
import permisos from '../Tools/VerificarPermisos'
function PrincipalAlmacen() {
    const { setTitulo } = useContext(ContextGloball);
    const [ventana, setVentana] = useState(0);
    const validarVentana = (item) => {
        var cls = ventana === item ? "itemMenuOk w-100" : "itemMenu w-100";
        return cls;
    }
    function getContenido() {
        if (ventana == 1)  {
            return (
                <ReporteReuqerimiento />
            )
        }
    }
    return (
        <>
            {ventana == 0 && <div className='container-fluid py-2'>
                <div className='row row-cols-1 row-cols-sm-2 row-cols-md-3 row-cols-lg-4 g-1'>
                    {permisos.validarPermiso('54') && <div className='col col-sm-6 col-md-4'>
                        <a className={`btn btn-sm text-light text-start bg-gradient w-100 ${validarVentana(1)}`}
                            onClick={() => { setVentana(1); setTitulo('Reporte Solicitudes'); }}>
                            <i className="fa-solid fa-tent-arrows-down"></i><span className="ms-1 "> Rep. Solicitudes</span></a>
                    </div>}
                </div>
            </div>}
            {ventana != 0 && <button className='btn text-danger btn-flotante' onClick={() => { setTitulo('MODULO ALMACEN'); setVentana(0) }}><i className="fa-solid fa-circle-xmark fa-2xl"></i></button>}
            {getContenido()}
        </>
    )
}

export default PrincipalAlmacen